import { AiQueryTarget } from '../../models/AiQueryTarget';

const PropipeBotUserId = 'system|propipe-ai';

export function shouldTrackPendingAiQuerySourceMessage(
  target: AiQueryTarget | null
): boolean {
  return target === AiQueryTarget.Propipe;
}

export function shouldClearPropipePendingState(
  userId: string,
  aiQuerySourceMessageId: number | null | undefined,
  pendingAiQuerySourceMessageId: number | null
): boolean {
  return (
    userId === PropipeBotUserId &&
    aiQuerySourceMessageId != null &&
    pendingAiQuerySourceMessageId != null &&
    aiQuerySourceMessageId === pendingAiQuerySourceMessageId
  );
}
